import { render, staticRenderFns } from "./ThemeChoose.vue?vue&type=template&id=3aee9ab2&scoped=true&"
import script from "./ThemeChoose.vue?vue&type=script&lang=js&"
export * from "./ThemeChoose.vue?vue&type=script&lang=js&"
import style0 from "./ThemeChoose.vue?vue&type=style&index=0&id=3aee9ab2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aee9ab2",
  null
  
)

export default component.exports